(function () {
  function mountBannerThreeContent() {
    var slide = document.querySelector('#shopify-section-home #anHero.hero .hero-slide:nth-child(3)');
    if (!slide || slide.querySelector('.an-hero-copy-layer--moment')) return;

    var scrim = document.createElement('div');
    scrim.className = 'an-hero-copy-scrim an-hero-copy-scrim--moment';
    scrim.setAttribute('aria-hidden', 'true');

    var layer = document.createElement('div');
    layer.className = 'an-hero-copy-layer an-hero-copy-layer--moment';
    layer.innerHTML = [
      '<div class="an-hero-copy an-hero-copy--moment">',
      '<h2>Every Moment Has A Scent</h2>',
      '<p>Curated fragrances for every mood, memory and moment.</p>',
      '<a class="an-hero-cta an-hero-cta--moment" href="#anMomentSection">Shop By Mood</a>',
      '</div>'
    ].join('');

    slide.appendChild(scrim);
    slide.appendChild(layer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountBannerThreeContent);
  } else {
    mountBannerThreeContent();
  }

  document.addEventListener('shopify:section:load', mountBannerThreeContent);
})();
